import GuestHeroImage from './GuestHeroImage';

export default GuestHeroImage;
